const createGasBrandMerchant = () => {};

export default createGasBrandMerchant;
